//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'SingleWebCoin',
  props: {
    coin: {
      type: Object,
      default: null
    },
    price: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      GreenImg: ['Green1.svg', 'Green2.svg', 'Green3.svg'],
      RedImg: ['Red1.svg', 'Red2.svg', 'Red3.svg']
    }
  },
  computed: {
    ...mapGetters({
      getSymbolFaName: 'coins/getSymbolFaName',
      buyDollarPrice: 'coins/buyDollarPrice',
      assets: 'coins/assets',
      watchList: 'watchList/watchList',
      latest: 'coins/latest',
      isGuest: 'auth/isGuest'
    }),
    isUsdtIrt () {
      return String(this.coin && this.coin.symbol).toUpperCase() === 'USDT_IRT'
    },
    logoSrc () {
      return '~/static/images/logo/' + this.coin.base + '.svg'
    },
    redRandom () {
      return this.RedImg[Math.floor(Math.random() * this.RedImg.length)]
    },
    greenRandom () {
      return this.GreenImg[Math.floor(Math.random() * this.GreenImg.length)]
    }
  }
}
